import { createSlice } from '@reduxjs/toolkit';

import {
  type ClientInformation,
  type IConfigState,
  type SetTheme,
  type ShowSidebar,
  type Tick,
  type ToggleSidebar,
} from './types';

const initialState: IConfigState = {
  url: '',
  showSidebar: false,
  theme: 'system',
  countryType: {
    isoCode: undefined,
    flag: undefined,
  },
  screenWidth: null,
  screenHeight: null,
  emailValidator: {
    addressBook: false,
    checkout: false,
    giftRegistryConfirm: false,
    giftRegistryContribution: false,
    login: false,
    watchdog: false,
  },
};

const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    showSidebarAction: (state: IConfigState, action: ShowSidebar): void => {
      state.showSidebar = action.payload.showSidebar;
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    toggleSidebar: (state: IConfigState, _action: ToggleSidebar): void => {
      state.showSidebar = !state.showSidebar;
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    tick: (_state: IConfigState, _action: Tick): void => {},

    setTheme: (state: IConfigState, action: SetTheme): void => {
      state.theme = action.payload.theme;
    },

    clientInformation: (
      state: IConfigState,
      action: ClientInformation,
    ): void => {
      state.screenWidth = action.payload.width;
      state.screenHeight = action.payload.height;
    },
  },
});

export const {
  showSidebarAction,
  clientInformation,
  toggleSidebar,
  tick,
  setTheme,
} = configSlice.actions;

export default configSlice.reducer;
